// script.js
import Sortable from 'sortablejs'
import {bottom} from '@popperjs/core'
import {tns} from 'tiny-slider'
import {defineCustomElement} from 'web-social-share'
import audioPlayer from "./audioPlayer";


require('bootstrap');

defineCustomElement()
const shareLinks = {
    displayNames: true,
    config: [
        {
            email: {
                socialShareUrl: '/',
                socialSharePopupWidth: 300,
                socialSharePopupHeight: 400,
            },
        },
        {
            copy: {
                socialShareUrl: '/',
            },
        },
        {
            facebook: {
                socialShareUrl: '/',
            },
        },
        {
            twitter: {
                socialShareUrl: '/',
            },
        },
        {
            pinterest: {
                socialShareUrl: '/',
            },
        },
        {
            linkedin: {
                socialShareUrl: '/',
            },
        },
        {
            reddit: {
                socialShareUrl: '/',
                socialSharePopupWidth: 300,
                socialSharePopupHeight: 400,
            },
        },
    ],
}

let currentAccessbilityData = {
    motion: null,
    colour: null,
    contrast: null,
    underline: false,
    readable: false,
}

const RESET_SEARCH_BUTTON = '#reset-facets'
const SEARCH_FORM_FACETS = '#form-facets';

const WELCOME_SLIDER_SELECTOR = '.qhs-slider'
const MEDIA_SLIDER_SELECTOR = '.qhs-media-slider'
const COOKIE_DEFAULT_TIME = 1000 * 60 * 60 * 12

const TAB_GROUP_SELECTION = '.block-tabGroupStart'
const EVENT_GROUP_SELECTION = '.block-eventTab';

const PLACEHOLDER_ID = 'qhs-search-form-placeholder'
const INPUT_ID = 'qhs-search-form-input'

const FONT_SIZE_SWITCHER_DOWN_SELECTOR = '.qhs-font-down'
const FONT_SIZE_SWITCHER_UP_SELECTOR = '.qhs-font-up'
const FONT_SIZE_KEY = '_font_size'

const PAGINATION_SELECTOR = '.qhs-pagination--browse'
const EVENT_PAGINATION_SELECTOR = '.qhs-event--pagination';

const pageState = { menuExpanded: false }

const blockGroupLayouts = ['tabsBlock','blockGroup', 'eventTab']

function isElementPresent(selector) {
    return document.querySelector(selector) !== null
}

function initializeWelcomePageSlider() {
    const sliderElement = document.querySelector(WELCOME_SLIDER_SELECTOR)
    const sliderInterval = window.parseInt(sliderElement.dataset.sliderInterval)
    const sliderSpeed = window.parseInt(sliderElement.dataset.sliderSpeed)

    // Very bad and should never happen.  Something probably went wrong
    // server-side.
    if (Number.isNaN(sliderInterval) || Number.isNaN(sliderSpeed)) {
        throw new Error('bad slider interval value from backend, bailing out')
    }

    const slider = tns({
        container: WELCOME_SLIDER_SELECTOR,
        autoplay: true,
        controls: false,
        nav: true,
        navPosition: bottom,
        controlsPosition: bottom,
        autoplayTimeout: sliderInterval,
        autoplayButtonOutput: false,
        speed: sliderSpeed,
    })
}

function initializeMediaSlider() {
    const slider = tns({
        container: MEDIA_SLIDER_SELECTOR,
        autoplay: false,
        controls: true,
        mouseDrag: true,
        controlsPosition: bottom,
        controlsText: [
            '<span style="font-size:2em">‹</span>',
            '<span style="font-size:2em">›</span',
        ],
        nav: true,
        navPosition: bottom,
        autoplayButtonOutput: false,
        autoHeight: true,
        center: true,
        responsive: {
            480: {},
            680: {},
            900: {},
            1024: {},
            1440: {},
            1441: {},
        },
    })
}

function initializeStyledPlaceholder() {
    const span = document.getElementById(PLACEHOLDER_ID)

    if (span === null) {
        return // Not found
    }

    const input = document.getElementById(INPUT_ID)

    const maybeShow = () => {
        if (input.value === '') {
            span.style.display = 'inline-block'
        }
    }

    const hide = () => {
        span.style.display = 'none'
    }

    // If the value was pre-filled by some query param, don't show the hint.
    const maybeHide = () => {
        if (input.value !== '') {
            hide()
        }
    }

    input.addEventListener('focus', hide)
    input.addEventListener('blur', maybeShow)

    maybeHide()
}

function initializePopoverMenu() {
    const openButton = document.querySelector('.qhs-menu-trigger-open')
    const closeButton = document.querySelector('.qhs-menu-trigger-close')
    const menuToggle = document.querySelector('.qhs-menu-toggle')
    const popoverMenu = document.querySelector('.qhs-menu-popover')

    const contentDiv = document.querySelector('.qhs-content')
    const footerDiv = document.querySelector('.qhs-footer')

    if (menuToggle) {
        menuToggle.addEventListener('click', (e) => {
            if (pageState.menuExpanded === true) {
                contentDiv.style.display = 'block'
                footerDiv.style.display = 'block'
                popoverMenu.style.display = 'none'
                openButton.style.display = 'inline'
                closeButton.style.display = 'none'
                pageState.menuExpanded = false
            } else {
                contentDiv.style.display = 'none'
                footerDiv.style.display = 'none'
                popoverMenu.style.display = 'flex'
                openButton.style.display = 'none'
                closeButton.style.display = 'inline'
                pageState.menuExpanded = true
            }
        })
    }
}

function initializeQuickFilter() {
    const select = document.querySelector('.qhs-quick-filter select')
    select.addEventListener('change', (e) => {
    })
}

function initializeFontSizeSwitcher() {
    const body = document.querySelector('body')
    const down = document.querySelector(FONT_SIZE_SWITCHER_DOWN_SELECTOR)
    const up = document.querySelector(FONT_SIZE_SWITCHER_UP_SELECTOR)

    const setSize = (size) => {
        body.style.fontSize = size + 'px'
        localStorage.setItem(FONT_SIZE_KEY, size)
    }

    let size = localStorage.getItem(FONT_SIZE_KEY)
    setSize(size)

    const delta = 2

    down.addEventListener('click', (e) => {
        let curSize = parseInt(body.style.fontSize.substr(0, 2))
        curSize = curSize || 18
        if (curSize > 18) {
            curSize -= delta
            setSize(curSize)
        }
    })

    up.addEventListener('click', (e) => {
        let curSize = parseInt(body.style.fontSize.substr(0, 2))
        curSize = curSize || 18
        if (curSize <= 24) {
            curSize += delta
            setSize(curSize)
        }
    })
}

function isCollectingFormPresent() {
    return document.querySelector('form[id^="collecting_form_"]') !== null
}

function styleCollectingForm() {
    // may not actually be necessary
}

function isDonationFormPresent() {
    return document.querySelector('form.donation') !== null
}

function initializeDonationForm() {
    const amountInput = document.querySelector(
        'form.donation input[name="amount"]'
    )

    const boxes = document.querySelectorAll('.donation-amount')

    boxes.forEach((el) => {
        el.addEventListener('click', (e) => {
            boxes.forEach((el) => {
                el.classList.remove('donation-selected')
            })
            el.target.classList.add('donation-selected')
        })
    })

    document.querySelectorAll('.donation-preset').forEach((el) => {
        el.addEventListener('click', (e) => {
            const element = e.target
            amountInput.value = element.dataset.amount
        })
    })

    document
        .querySelector('.donation-user-set-amount')
        .addEventListener('change', (e) => {
            amountInput.value = e.target.value
        })
}

function choose(choices) {
    const index = Math.floor(Math.random() * choices.length)
    return choices[index]
}

function randomizePageTitleAccent() {
    // const title = document.querySelector('.qhs-page-content > .blocks > h2');
    const title = document.querySelector('.qhs-block-title')

    const chosenClass = choose([
        'qhs-page-title-accent1',
        'qhs-page-title-accent2',
    ])

    if (title !== null) {
        title.classList.add(chosenClass)
    }
}

/**
 * Enable block sorting.
 *
 * @param object blockList
 */
function enableSorting(blockList) {
    new Sortable(blockList, {
        draggable: '.block',
        handle: '.sortable-handle',
        group: 'block-list',
        swapThreshold: 0.9,
        forceAutoScrollFallback: true,
        onStart: function (e) {
            var editor = $(e.item).find('.wysiwyg').ckeditor().editor
            if (editor) {
                editor.destroy()
            }
        },
        onEnd: function (e) {
            wysiwyg($(e.item))
        },
        onMove: function (e) {
            // Prevent users from dropping blockGroups into other blockGroups.
            const toList = $(e.to)
            const block = $(e.dragged)
            if (
                toList.hasClass('block-group-blocks') &&
                blockGroupLayouts.includes(block.data('block-layout'))
            ) {
                return false
            }
        },
        onAdd: function (e) {
            // Set the span of a blockGroup when adding a block to it.
            const toList = $(e.to)
            if (toList.hasClass('block-group-blocks')) {
                const blockGroup = toList.closest('.block-group')
                const blocks = toList.find('.block')
                blockGroup.find('input.block-group-span').val(blocks.length)
            }
        },
        onRemove: function (e) {
            // Set the span of a blockGroup when removing a block from it.
            const fromList = $(e.from)
            if (fromList.hasClass('block-group-blocks')) {
                const blockGroup = fromList.closest('.block-group')
                const blocks = fromList.find('.block')
                blockGroup.find('input.block-group-span').val(blocks.length)
            }
        },
    })
}

function initializeShareSystem() {
    const sharebutton = document.querySelector('#qhsShareButton')
    if (sharebutton && sharebutton != undefined) {
        sharebutton.addEventListener('click', function (e) {
            e.preventDefault()
            showSharePopUp()
        })
    }

    const shareElem = document.getElementsByTagName('web-social-share')
    if (shareElem && shareElem.length > 0) {
        shareElem[0].share = shareLinks
    }
}

function setCookie(cname, cvalue, exdays = COOKIE_DEFAULT_TIME) {
    const d = new Date()
    d.setTime(d.getTime() + exdays)
    let expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cvalue + ';' + expires + '; path=/'
}

function getCookie(cname) {
    let name = cname + '='
    let decodedCookie = decodeURIComponent(document.cookie)
    let ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return '{}'
}

function initializeBrowsePagination(paginationSelector = PAGINATION_SELECTOR, paginationCookieString = 'pagination_data') {
    const containers = document.querySelectorAll(paginationSelector)

    containers.forEach((container) => {
        let nextButton = container.querySelector('#qhs-next-pagination-button')
        let prevButton = container.querySelector(
            '#qhs-previous-pagination-button'
        )

        nextButton.addEventListener(
            'click',
            function (e) {
                e.preventDefault();
                handleNextPagination(e, container, paginationCookieString)
            },
            container, paginationCookieString
        )

        prevButton.addEventListener(
            'click',
            function (e) {
                e.preventDefault();
                handlePrevPagination(e, container, paginationCookieString)
            },
            container, paginationCookieString
        )
    }, paginationCookieString);
}

function handlePrevPagination(e, container, cookieName = 'pagination_data') {
    let cookie = JSON.parse(getCookie(cookieName))[container.getAttribute('data-pagination-key')];
    let pageNum = 0
    if (cookie != null) {
        pageNum = cookie - 1
    }
    handlePaginationCookie(container, pageNum, cookieName)
    location.reload()
}

function handleNextPagination(e, container, cookieName = 'pagination_data') {
    let cookie = JSON.parse(getCookie(cookieName))[container.getAttribute('data-pagination-key')];
    let pageNum = 0
    if (cookie  != null) {
        pageNum = cookie + 1
    }

    handlePaginationCookie(container, pageNum, cookieName)
    location.reload()
}

function handlePaginationCookie(container, pageNum, cookieName = 'pagination_data') {
    let data = getCookie(cookieName)
    if (!data) {
        return ''
    }

    data = JSON.parse(data)
    let pageKey = container.getAttribute('data-pagination-key')
    data[pageKey] = pageNum

    setCookie(
        cookieName,
        encodeURIComponent(JSON.stringify(data))
    );
}

function showSharePopUp() {
    updateShareLinks()
    toggleSharePopUp(true)
}

function toggleSharePopUp(showValue) {
    const elem = document.getElementsByTagName('web-social-share')
    if (elem && elem.length > 0) {
        elem[0].show = showValue
    }
}

function updateShareLinks() {
    let link = window.location.href
    shareLinks.config.forEach((element) => {
        element[Object.keys(element)[0]].socialShareUrl = link
    })
}

function setupMediaBounce() {
    let mediaLinks = document.querySelectorAll('.media-render a')
    mediaLinks.forEach((element) => {
        element.setAttribute('target', '_blank')
    })
}

function initializeMenuToggle() {
    let menuLinks = document.querySelector('.qhs-menu-popover-ul')
    if (menuLinks) {
        Array.from(menuLinks.children).forEach((element) => {
            element.addEventListener(
                'click',
                function (e) {
                    element.classList.toggle('toggle')
                },
                element
            )
        })
    }
}

function initializeFooterMenuToggle() {
    let menuLinks = document.querySelector('.qhs-footer-menu')
    if (menuLinks) {
        Array.from(menuLinks.children).forEach((element) => {
            element.addEventListener(
                'click',
                function (e) {
                    element.classList.toggle('toggle')
                },
                element
            )
        })
    }
}
// Preview the page layout.
const previewPageLayout = function () {
    const previewDiv = $('#layout-preview')
    previewDiv.empty()
    const pageLayoutSelect = $('#page-layout-select')
    const gridColumns = parseInt(
        $('#page-layout-grid-columns-select').val(),
        10
    )
    if ('grid' === pageLayoutSelect.val()) {
        previewDiv
            .css('grid-template-columns', `repeat(${gridColumns}, 1fr)`)
            .empty()
    }
    let inBlockGroup = false
    let blockGroupSpan
    let blockGroupCurrentSpan
    let blockGroupDiv
    $('.block').each(function () {
        const thisBlock = $(this)
        const blockLayout = thisBlock.data('block-layout')
        if (blockGroupLayouts.includes(blockLayout)) {
            // The blockGroup block gets special treatment.
            if (inBlockGroup) {
                // Blocks may not overlap.
                previewDiv.append(blockGroupDiv)
            }
            inBlockGroup = true
            blockGroupSpan = parseInt(
                thisBlock.find('.block-group-span').val(),
                10
            )
            blockGroupCurrentSpan = 0
            if ('grid' === pageLayoutSelect.val()) {
                blockGroupDiv = $(
                    `<div class="layout-previewing-block-group" style="display: grid; grid-template-columns: repeat(${gridColumns}, 1fr); grid-column: span ${gridColumns};">`
                )
            } else {
                blockGroupDiv = $('<div class="layout-previewing-block-group">')
            }
        } else {
            const selectedTooltip = $(
                '<div class="selected-tooltip" title="Selected">'
            )
            const blockDiv = $('<div class="layout-previewing-block">')
            if ('grid' === pageLayoutSelect.val()) {
                const positionSelect = thisBlock.find(
                    '.block-page-layout-grid-column-position-select'
                )
                const positionSelectValue =
                    parseInt(positionSelect.val(), 10) || 'auto'
                const spanSelect = thisBlock.find(
                    '.block-page-layout-grid-column-span-select'
                )
                const spanSelectValue = parseInt(spanSelect.val(), 10)
                blockDiv.css(
                    'grid-column',
                    `${positionSelectValue} / span ${spanSelectValue}`
                )
            }
            if (thisBlock.hasClass('layout-previewing')) {
                blockDiv.addClass('layout-previewing').append(selectedTooltip)
            }
            blockDiv.hover(
                function () {
                    thisBlock.addClass('hovered-block')
                    $(this).addClass('hovered-block')
                },
                function () {
                    thisBlock.removeClass('hovered-block')
                    $(this).removeClass('hovered-block')
                }
            )
            inBlockGroup
                ? blockGroupDiv.append(blockDiv)
                : previewDiv.append(blockDiv)
        }
        if (inBlockGroup) {
            // The blockGroup block gets special treatment.
            if (blockGroupCurrentSpan == blockGroupSpan) {
                previewDiv.append(blockGroupDiv)
                inBlockGroup = false
            } else {
                blockGroupCurrentSpan++
            }
        }
    })
    if (inBlockGroup) {
        // Close the blockGroup block if not already closed.
        previewDiv.append(blockGroupDiv)
    }
    Omeka.openSidebar($('#layout-preview-sidebar'))
}

function initializeAllHoverStates() {
    let hoverables = document.querySelectorAll('.hover-container')
    hoverables.forEach((hoverContainer) => {
        let content = hoverContainer.querySelector('.hover-content')
        let showLink = hoverContainer.querySelector('.hover-link--show')
        let hideLink = hoverContainer.querySelector('.hover-link--hide')
        hoverContainer.addEventListener(
            'onmouseover',
            function (e) {
                content.classList.add('hover-content--toggled')
            },
            content
        )

        hoverContainer.addEventListener(
            'onmouseout',
            function (e) {
                content.classList.remove('hover-content--toggled')
            },
            content
        )

        hoverContainer.addEventListener(
            'touchstart',
            function (e) {
                content.classList.toggle('hover-content--toggled')
            },
            content
        )

        showLink.addEventListener(
            'onmouseover',
            function (e) {
                e.preventDefault()
                content.classList.add('hover-content--toggled')
            },
            content
        )

        showLink.addEventListener(
            'onmouseout',
            function (e) {
                e.preventDefault()
                content.classList.remove('hover-content--toggled')
            },
            content
        )

        showLink.addEventListener(
            'touchstart',
            function (e) {
                e.preventDefault()
                content.classList.toggle('hover-content--toggled')
            },
            content
        )

        hideLink.addEventListener(
            'onmouseover',
            function (e) {
                e.preventDefault()
                content.classList.add('hover-content--toggled')
            },
            content
        )

        hideLink.addEventListener(
            'onmouseout',
            function (e) {
                e.preventDefault()
                content.classList.remove('hover-content--toggled')
            },
            content
        )

        hideLink.addEventListener(
            'touchstart',
            function (e) {
                e.preventDefault()
                content.classList.toggle('hover-content--toggled')
            },
            content
        )
    })
}

function setupAccessibilityOptions() {
    initializePopupClick()
    initializeTabs()
    initializeResetButton()
    initializeOptions()
    handleStoredAccessibilityData()
}

function initializePopupClick() {
    let accessibilityButton = document.querySelector(
        '.qhs-accessibility-button'
    )
    let accessibilityPopupOverlay = document.querySelector(
        '.qhs-accessibility-popup-overlay'
    )
    let accessibilityPopup = document.querySelector('.qhs-accessibility-popup')
    let accessibilityCloseButton = document.querySelector('.qhs-close-button')

    if (accessibilityCloseButton) {
        accessibilityButton.addEventListener(
            'click',
            function (e) {
                e.preventDefault()
                accessibilityPopupOverlay.classList.add('is-active')
                accessibilityPopup.classList.add('is-active')
            },
            accessibilityPopupOverlay,
            accessibilityPopup
        )
    }

    if (accessibilityPopupOverlay) {
        accessibilityPopupOverlay.addEventListener(
            'click',
            function (e) {
                e.preventDefault()
                accessibilityPopupOverlay.classList.toggle('is-active')
                accessibilityPopup.classList.toggle('is-active')
            },
            accessibilityPopupOverlay,
            accessibilityPopup
        )
    }

    if (accessibilityCloseButton) {
        accessibilityCloseButton.addEventListener(
            'click',
            function (e) {
                e.preventDefault()
                accessibilityPopupOverlay.classList.toggle('is-active')
                accessibilityPopup.classList.toggle('is-active')
            },
            accessibilityPopupOverlay,
            accessibilityPopup
        )
    }
}

function initializeTabs() {
    let popupContainer = document.querySelector('.qhs-accessibility-popup')
    if (popupContainer) {
        let labelSections = popupContainer.querySelectorAll(
            '.qhs-accessibility-tab-label'
        )
        let contentSections = popupContainer.querySelectorAll(
            '.qhs-accessibility-tab-content'
        )
        if (labelSections) {
            labelSections.forEach((element, index) => {
                element.addEventListener('click', function (e) {
                    e.preventDefault()
                    labelSections.forEach((labelElement, labelIndex) => {
                        if (
                            labelIndex != index &&
                            labelElement.classList.contains('is-active')
                        ) {
                            labelElement.classList.remove('is-active')
                        } else if (labelIndex == index) {
                            labelElement.classList.toggle('is-active')
                        }
                    }, index)

                    contentSections.forEach((contentElement, contentIndex) => {
                        if (
                            contentIndex != index &&
                            contentElement.classList.contains('is-active')
                        ) {
                            contentElement.classList.remove('is-active')
                        } else if (contentIndex == index) {
                            contentElement.classList.toggle('is-active')
                        }
                    }, index)
                })
            }, contentSections)
        }
    }
}

function initializeUnderlineButton() {
    let popupContainer = document.querySelector('.qhs-accessibility-popup')
    if (popupContainer) {
        let bodyElm = document.querySelector('body')
        let underlineButton = popupContainer.querySelector(
            '.qhs-underline-toggle--button'
        )
        underlineButton.addEventListener(
            'click',
            function (e) {
                e.preventDefault()

                bodyElm.classList.toggle('qhs-accessibility-underline-links')
                var classState = bodyElm.classList.contains(
                    'qhs-accessibility-readable-font'
                )
                handleUnderlineButton(classState)
                currentAccessbilityData.underline = classState
                storeAccessibilityData()
            },
            underlineButton
        )
    }
}

function intializeReadableFontButton() {
    let popupContainer = document.querySelector('.qhs-accessibility-popup')
    if (popupContainer) {
        let bodyElm = document.querySelector('body')
        let readableButton = popupContainer.querySelector(
            '.qhs-readable-toggle--button'
        )

        readableButton.addEventListener(
            'click',
            function (e) {
                e.preventDefault()
                bodyElm.classList.toggle('qhs-accessibility-readable-font')
                var classState = bodyElm.classList.contains(
                    'qhs-accessibility-readable-font'
                )
                handleReadableButton(classState)
                currentAccessbilityData.readable = classState
                storeAccessibilityData()
            },
            readableButton
        )
    }
}

function initializeFontSize() {
    let popupContainer = document.querySelector('.qhs-accessibility-popup')
    if (popupContainer) {
        let fontLabel = popupContainer.querySelector('.qhs-font-size-input')
        let fontUpbutton = popupContainer.querySelector('.qhs-font-up')
        let fontDownbutton = popupContainer.querySelector('.qhs-font-down')
        var size = localStorage.getItem(FONT_SIZE_KEY)

        fontLabel.innerHTML = size + 'px'
        fontUpbutton.addEventListener(
            'click',
            function (e) {
                var size = localStorage.getItem(FONT_SIZE_KEY)
                fontLabel.innerHTML = size + 'px'
            },
            fontLabel
        )

        fontDownbutton.addEventListener(
            'click',
            function (e) {
                var size = localStorage.getItem(FONT_SIZE_KEY)
                fontLabel.innerHTML = size + 'px'
            },
            fontLabel
        )
    }
}

function initializeOptions() {
    initializeUnderlineButton()
    intializeReadableFontButton()
    initializeFontSize()
    intializeContrastOptions()
    intializeColourOptions()
    initializeMotionOptions()
    initializeMobileMenu()
}

function storeAccessibilityData() {
    let cookieStatus = setCookie(
        'qhs_accessbility_data',
        JSON.stringify(currentAccessbilityData)
    )
}

function initializeMotionOptions() {
    let motionRadios = document.querySelectorAll(
        '.qhs-accessibility-button-container input[name="motion-options"]'
    )

    motionRadios.forEach((element) => {
        element.addEventListener('change', function (e) {
            handleRadioOptions('motion', element.value)
            currentAccessbilityData.motion = element.value
            storeAccessibilityData()
        })
    })
}

function intializeColourOptions() {
    let contrastRadios = document.querySelectorAll(
        '.qhs-accessibility-button-container input[name="colour-options"]'
    )

    if (contrastRadios) {
        contrastRadios.forEach((element) => {
            element.addEventListener('change', function (e) {
                handleRadioOptions('colour', element.value)
                currentAccessbilityData.colour = element.value
                storeAccessibilityData()
            })
        })
    }
}

function intializeContrastOptions() {
    let contrastRadios = document.querySelectorAll(
        '.qhs-accessibility-button-container input[name="contrast-options"]'
    )

    if (contrastRadios) {
        contrastRadios.forEach((element) => {
            element.addEventListener('change', function (e) {
                handleRadioOptions('contrast', element.value)
                currentAccessbilityData.contrast = element.value
                storeAccessibilityData()
            })
        })
    }
}

function handleStoredAccessibilityData() {
    const cookieData = getCookie('qhs_accessbility_data')
    if (cookieData) {
        let AccessibilityData = JSON.parse(cookieData)
        if (AccessibilityData) {
            $('#' + AccessibilityData.contrast + '-contrast').click()
            $('#' + AccessibilityData.motion + '-motion').click()
            $('#' + AccessibilityData.colour + '-colours').click()

            handleRadioOptions('motion', AccessibilityData.motion)
            handleRadioOptions('colour', AccessibilityData.colour)
            handleRadioOptions('contrast', AccessibilityData.contrast)
            handleReadableButton(AccessibilityData.readable)
            handleUnderlineButton(AccessibilityData.underline)
            return null
        }
    }

    handleAccessibilityReset()
}

function handleAccessibilityReset() {
    $('#standard-contrast').click()
    $('#standard-motion').click()
    $('#standard-colours').click()
    handleReadableButton(false)
    handleUnderlineButton(false)
    storeAccessibilityData()
}

function handleReadableButton(state) {
    let readButton = document.querySelector('.qhs-readable-toggle--button')
    if (readButton) {
        if (state) {
            readButton.classList.add('qhs-readable-toggle--button-active')
            readButton.innerHTML = 'On'
            currentAccessbilityData.readable = true
        } else {
            readButton.classList.remove('qhs-readable-toggle--button-active')
            readButton.innerHTML = 'Off'
            currentAccessbilityData.readable = false
        }
    }
}

function handleUnderlineButton(state) {
    let underlineButton = document.querySelector(
        '.qhs-underline-toggle--button'
    )
    if (underlineButton) {
        if (state) {
            underlineButton.classList.add('qhs-underline-toggle--button-active')
            underlineButton.innerHTML = 'On'
            currentAccessbilityData.underline = true
        } else {
            underlineButton.classList.remove(
                'qhs-underline-toggle--button-active'
            )
            underlineButton.innerHTML = 'Off'
            currentAccessbilityData.underline = false
        }
    }
}

function handleRadioOptions(type, radioVal = 'standard') {
    switch (type) {
        case 'motion':
            handleMotionOptions(radioVal)
            break
        case 'colour':
            handleColourOptions(radioVal)
            break
        case 'contrast':
            handleContrastOptions(radioVal)
            break
    }
}

function handleContrastOptions(radioVal) {
    let bodyElm = document.querySelector('body')
    var options = ['high', 'low', 'negative', 'standard']
    options.splice(options.indexOf(radioVal), 1)
    if (
        !bodyElm.classList.contains('qhs-accessibility-contrast--' + radioVal)
    ) {
        bodyElm.classList.add('qhs-accessibility-contrast--' + radioVal)
    }
    options.forEach((classMod) => {
        let classString = 'qhs-accessibility-contrast--' + classMod
        if (bodyElm.classList.contains(classString)) {
            bodyElm.classList.remove(classString)
        }
    })
}

function handleColourOptions(radioVal) {
    let bodyElm = document.querySelector('body')
    var options = ['light', 'dark', 'greyscale', 'standard']
    options.splice(options.indexOf(radioVal), 1)
    if (!bodyElm.classList.contains('qhs-accessibility-colour--' + radioVal)) {
        bodyElm.classList.add('qhs-accessibility-colour--' + radioVal)
    }
    options.forEach((classMod) => {
        let classString = 'qhs-accessibility-colour--' + classMod
        if (bodyElm.classList.contains(classString)) {
            bodyElm.classList.remove(classString)
        }
    })
}

function handleMotionOptions(radioVal) {
    let bodyElm = document.querySelector('body')
    var options = ['reduced', 'standard']

    options.splice(options.indexOf(radioVal), 1)
    if (!bodyElm.classList.contains('qhs-accessibility-motion--' + radioVal)) {
        bodyElm.classList.add('qhs-accessibility-motion--' + radioVal)
    }
    options.forEach((classMod) => {
        let classString = 'qhs-accessibility-motion--' + classMod
        if (bodyElm.classList.contains(classString)) {
            bodyElm.classList.remove(classString)
        }
    })
}

function initializeResetButton() {
    let popupContainer = document.querySelector('.qhs-accessibility-popup')
    if (popupContainer) {
        let resetButton = popupContainer.querySelector('.qhs-reset-button')

        if (resetButton) {
            resetButton.addEventListener('click', function (e) {
                e.preventDefault()
                handleAccessibilityReset()
            })
        }
    }
}

function initializeTabGroups(blockSelector = TAB_GROUP_SELECTION) {
    let tabGroups = document.querySelectorAll(blockSelector)
    tabGroups.forEach((tabGroup) => {
        let tabLabels = tabGroup.querySelector('.qhs-tab-labels').querySelectorAll('.qhs-tab-label');
        let tabs = tabGroup.querySelector('.qhs-tab-contents').querySelectorAll('.qhs-tab-content')
        if (tabLabels && tabs) {
            tabLabels.forEach((element, index) => {
                element.addEventListener('click', function (e) {
                    e.preventDefault()
                    tabLabels.forEach((labelElement, labelIndex) => {
                        if (
                            labelIndex !== index &&
                            labelElement.classList.contains('is-active')
                        ) {
                            labelElement.classList.remove('is-active')
                        } else if (labelIndex === index && !labelElement.classList.contains('is-active')) {
                            labelElement.classList.toggle('is-active')
                            saveTabState(labelElement.id);
                        }
                    }, index)

                    tabs.forEach((contentElement, contentIndex) => {
                        if (
                            contentIndex !== index &&
                            contentElement.classList.contains('is-active')
                        ) {
                            contentElement.classList.remove('is-active')
                        } else if (contentIndex === index && !contentElement.classList.contains('is-active')) {
                            contentElement.classList.toggle('is-active')
                        }
                    }, index)
                })
                if (element.classList.contains('is-active')) {
                    tabs.forEach((contentElement, contentIndex) => {
                        if (
                            contentIndex !== index &&
                            contentElement.classList.contains('is-active')
                        ) {
                            contentElement.classList.remove('is-active')
                        } else if (contentIndex === index) {
                            contentElement.classList.toggle('is-active')
                        }
                    }, index)
                }
            }, tabs)
            const tabID = loadTabState();
            if (tabID && (typeof tabID === 'string' || tabID instanceof String)) {
                const currentTab = document.querySelector('#' + tabID);
                if (currentTab && !currentTab.classList.contains('is-active')) {
                    currentTab.click()
                }
            } else {
                if(tabLabels[0] && !tabLabels[0].classList.contains('is-active')){
                    tabLabels[0].click()
                }
            }
        }
    })
}

function saveTabState(id) {
    setCookie('tab_state', JSON.stringify(id), COOKIE_DEFAULT_TIME)
}

function loadTabState() {
    return JSON.parse(getCookie('tab_state'))
}

function initializeMobileMenu() {
    var openButton = document.querySelector('.search-facets-mobile-open')
    var closeButton = document.querySelector('.search-facets-mobile-close')
    var FacetMenu = document.querySelector('.search-facets')

    if (openButton) {
        openButton.addEventListener('click', function (e) {
            e.preventDefault()
            FacetMenu.classList.toggle('search-facets--active')
        })
    }

    if (closeButton) {
        closeButton.addEventListener('click', function (e) {
            e.preventDefault()
            FacetMenu.classList.toggle('search-facets--active')
        })
    }
}

function handleFilterClicking() {
    let facets = document.querySelectorAll('.search-facet')
    facets.forEach(facet => {
        facet.querySelector('h4').addEventListener('click', function (e) {
            e.preventDefault();
            toggleAllOtherFilters(facet, facets);
            processFilterClick(facet);
        }, facets);
        }
    );
}

function toggleAllOtherFilters(filter, facets) {
    facets.forEach(facet => {
        if (facet !== filter) {
            if (facet.classList.contains('filter-facet-active')) {
                facet.classList.remove('filter-facet-active');
            }
        }
    });
}

function processFilterClick(filter) {
    if (filter.classList.contains('filter-facet-active')) {
        filter.classList.remove('filter-facet-active');
    } else {
        filter.classList.add('filter-facet-active');
    }
}

function isMusicPlayerPresent() {
    return document.querySelector('.music-player--qhs') !== null && document.querySelector('.qhs-music-player--inline') !== null;
}

function getAudioFiles() {
    let filesData = [];
    const audios = document.querySelectorAll('.qhs-audio-files audio');
    audios.forEach(file => {
        const tempArray = [];
        tempArray['title'] = file.dataset.audioLabel || file.dataset.audioFileTitle;
        tempArray['file'] = file.getAttribute('src');
        tempArray['howl'] = null;
        filesData.push(tempArray);
    }, filesData);
    return filesData;
}

function initializeMusicPlayer() {
    let parentElement = document.querySelector('.qhs-music-player--inline');
    let config = {

    };
    let audioFiles = getAudioFiles();
    let AudioSystem;
    AudioSystem = new audioPlayer(parentElement, config, audioFiles);
}

function initializeSearchResetButton() {
    let resetButton = document.querySelector(RESET_SEARCH_BUTTON);
    let searchFormFacets = document.querySelector(SEARCH_FORM_FACETS);
    resetButton.addEventListener('click', (event) => {
        event.preventDefault();
        searchFormFacets.reset();
        const url = clearSearchParams();
        window.history.pushState({}, '', url);
        window.location.reload();
    });
}

function clearSearchParams()
{
    const currURL= window.location.href; //get current address
    const afterDomain = currURL.substring(currURL.lastIndexOf('/') + 1);
    return afterDomain.split("?")[0];
}

function isResetButtonPresent() {
    return document.querySelector(RESET_SEARCH_BUTTON) !== null;
}

function onReady(e) {


    if(isMusicPlayerPresent()){
        initializeMusicPlayer();
    }

    if (!isElementPresent('.admin-body')) {
        initializeFontSizeSwitcher()
    }

    if (isElementPresent(WELCOME_SLIDER_SELECTOR)) {
        initializeWelcomePageSlider()
    }

    if (isElementPresent(MEDIA_SLIDER_SELECTOR)) {
        initializeMediaSlider()
    }

    initializeStyledPlaceholder()
    initializePopoverMenu()
    initializeShareSystem()
    initializeMenuToggle()
    initializeFooterMenuToggle()
    initializeAllHoverStates()
    setupMediaBounce()
    setupAccessibilityOptions()
    handleFilterClicking()

    if (isCollectingFormPresent()) {
        styleCollectingForm()
    }

    if (isDonationFormPresent()) {
        initializeDonationForm()
    }

    if(isResetButtonPresent()){
        initializeSearchResetButton();
    }

    randomizePageTitleAccent()

    if (!isElementPresent('#blocks')) {
        if (isElementPresent(TAB_GROUP_SELECTION)) {
            initializeTabGroups()
        }
        if(isElementPresent(EVENT_GROUP_SELECTION)){
            initializeTabGroups(EVENT_GROUP_SELECTION)
        }
        if (isElementPresent(PAGINATION_SELECTOR)) {
            initializeBrowsePagination()
        }
        if (isElementPresent(EVENT_PAGINATION_SELECTOR)) {
            initializeBrowsePagination(EVENT_PAGINATION_SELECTOR, 'event_pagination_data')
        }

    }
}

window.addEventListener('load', onReady)
